
export default {
    name: 'TicaOrderchampLogo',
}
